import styled, {css, keyframes} from 'styled-components';
import { cover, easeInOut } from 'polished';

import { FAMILY_FONT_PRIMARY, TITLE_SIZE_5 } from '../../const/text';
import { PRIMARY_COLOR, SECONDARY_COLOR, SECONDARY_COLOR_6 } from '../../const/color';
import { animated } from 'react-spring';

const blinking = keyframes`
  0% {
    opacity: 1;
  }
  
  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: aliceblue;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  ${cover()}
`;

export const Item = styled.div<{ preparing: boolean }>`
  width: 4.8em;
  height: 4.8em;
  box-shadow: 0 .8em 2.4em rgba(0, 0, 0, 0.08);
  border-radius: .4em;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => props.preparing && css`animation: ${blinking} 1.8s ease-in-out infinite;`}
  justify-content: center;
`;

export const Percent = styled(animated.div)`
  width: 3.2em;
  height: 1.6em;
  
  font-family: ${FAMILY_FONT_PRIMARY};
  font-size: ${TITLE_SIZE_5 / 10}em;
  line-height: 130%;
  text-align: center;
  letter-spacing: 0.005em;
  text-transform: uppercase;
  color: ${SECONDARY_COLOR};
`;

export const Bar = styled.div`
  width: 2.8em;
  height: .2em;
  border-radius: .8em;
  background-color: ${SECONDARY_COLOR_6};
  display: flex;
  justify-content: center;
  
  > div {
    border-radius: .8em;
    height: 100%;
    background-color: ${PRIMARY_COLOR};
    will-change: width;
  }
`;
